import { ArrowUpDown, Eye } from "lucide-react";
import { DataTable } from "../../../components/DataTable";
import { Badge } from "../../../components/ui/badge";
import { Button } from "../../../components/ui/button";
import { useNavigate } from "react-router-dom";
import DialogDeleteSubCategory from "./DialogDeleteSubCategory";
import { useLanguage } from "../../../context/LanguageContext";
import { SubCategoriesData } from "../../../lib/languages";

const TableSubCategory = ({ data, getAllSubCategories, category }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = SubCategoriesData[language] || SubCategoriesData["en"];

  const columns = [
    {
      accessorKey: `title.en`,
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            className="p-0 hover:bg-transparent"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            {t.titleEn}
            <ArrowUpDown className="h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => {
        const title = row.original.title;
        return title?.en || "---";
      },
    },
    {
      accessorKey: `title.ar`,
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            className="p-0 hover:bg-transparent"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            {t.titleAr}
            <ArrowUpDown className="h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => {
        const title = row.original.title;
        return title?.ar || "---";
      },
    },
    {
      accessorKey: "created_by.name",
      header: t.createdBy,
    },
    {
      accessorKey: "course_count",
      header: t.courseCount,
    },
    {
      accessorKey: "status",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            className="p-0 hover:bg-transparent"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            {t.status}
            <ArrowUpDown className="h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => {
        const status = row.getValue("status");
        return (
          <Badge variant={status ? "default" : "destructive"}>
            {status ? t.active : t.inactive}
          </Badge>
        );
      },
    },
    {
      id: "actions",
      header: t.actions,
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="flex items-center gap-2">
            <Button
              size="icon"
              className="rounded-xl h-9"
              onClick={() =>
                navigate(`/admin/sub-category-view/${item.id}`, {
                  state: { category },
                })
              }
            >
              <Eye />
            </Button>
            <DialogDeleteSubCategory
              subCategory={item}
              category={category}
              getAllSubCategories={getAllSubCategories}
            />
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      title={t.subCategoriesByTitle}
      filterNames={[`title_ar`, `title_en`]}
    />
  );
};

export default TableSubCategory;
